// Hook personalizado useAuth
// Wrapper del hook useAuth del AuthContext para facilitar su uso

import { useContext } from 'react'
import AuthContext from '../contexts/AuthContext'

/**
 * Hook personalizado para acceder al contexto de autenticación
 * @returns {Object} Objeto con el estado y funciones de autenticación
 * 
 * @example
 * const { currentUser, login, logout, loading } = useAuth()
 */
export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider')
  }
  return context
}

export default useAuth

